const m = await (window.navigation
  ? import("./navigation").catch(() => import("./compatibility"))
  : import("./compatibility"));

export const softNavigate = m.softNavigate;
export const registerSoftNavigate = m.registerSoftNavigate;
